import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

export interface IConfirmService {
  confirm(message: string): Observable<boolean>;
}

@Injectable({
  providedIn: 'root',
})
export class ConfirmService implements IConfirmService {
  constructor() {}

  public confirm(message: string) {
    return of(confirm(message));
  }
}
